import "./card_plugin";

function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}

const singleton = Symbol();
const singletonEnforcer = Symbol();
class UCard {
  constructor(enforcer, card) {
    if (enforcer != singletonEnforcer) {
      throw "cannot construct singleton";
    }
    this._card = card;
  }

  static downloadPlugin() {
    window.open(UCard.XDJA_PLUGIN_URL);
  }

  static async getUCard() {
    if (!this._card) {
      this[singleton] = null;
    }
    if (!this[singleton]) {
      const card = await UCard.getCard();
      this[singleton] = new UCard(singletonEnforcer, card);
    }
    return this[singleton];
  }

  static async initCard() {
    return new Promise(function (reslove, reject) {
      Plugin.init(function (res) {
        if (res.code.message === "success") {
          reslove();
        } else {
          reject(res.code.message);
        }
      });
    });
  }

  static async getCard() {
    await UCard.initCard();
    return new Promise(function (reslove, reject) {
      Plugin.getCards(function (data) {
        if (data.code) {
          reject(data.code.message);
        } else {
          if (data.length > 0) {
            reslove(data[0]);
          } else {
            reject("获取 card 实例失败");
          }
        }
      });
    });
  }

  setOnPullCard(fn) {
    if (!isFunction(fn)) {
      throw new Error("fn is not function");
    }
    this._card.pullCard((data) => {
      if (data.success) {
        fn();
        this.destoryCard();
      }
    });
  }

  destoryCard() {
    this._card = null;
  }

  setPIN(oldVal, newVal) {
    return new Promise((reslove, reject) => {
      this._card.safeChangePin(oldVal, newVal, function (data) {
        if (data.success) {
          reslove();
        } else {
          reject(data.message);
        }
      });
    });
  }

  verifyPin(pin = "") {
    return new Promise((reslove, reject) => {
      this._card.safePin(pin, function (data) {
        if (data.success) {
          reslove();
        } else {
          reject(data.message);
        }
      });
    });
  }

  getCardId() {
    return new Promise((reslove, reject) => {
      this._card.getCardId((data) => {
        if (data.success) {
          reslove(data.cardId);
        } else {
          reject(data.message);
        }
      });
    });
  }

  getCardCert() {
    return new Promise((reslove, reject) => {
      this._card.getCert(0, (data) => {
        if (data.success) {
          reslove(data.cert);
        } else {
          reject(data.message);
        }
      });
    });
  }

  async getCardInfo() {
    const cardId = await this.getCardId();
    const cardCert = await this.getCardCert();
    return {
      id: cardId,
      cert: cardCert,
    };
  }

  async getCardInfoByPIN(pin = "") {
    await this.verifyPin(pin);
    const ret = await this.getCardInfo();
    return ret;
  }
}

UCard.XDJA_PLUGIN_URL =
  "https://puma-root.obs.cn-east-2.myhuaweicloud.com/lobe/safe_xdja_v4.0.1.4003.exe";

export { UCard };
